function parse_json_string(value, fallback = {}) {
  try {
    return JSON.parse(value);
  } catch {
    return fallback;
  }
}

function parse_unknown_data(value, fallback = {}) {
  let parsed_value = value;

  for (let attempt = 0; attempt < 2 && typeof parsed_value === 'string'; attempt += 1) {
    parsed_value = parse_json_string(parsed_value, parsed_value);
  }

  if (typeof parsed_value === 'string') {
    const trimmed_value = parsed_value.trim();
    return trimmed_value ? trimmed_value : fallback;
  }

  return parsed_value ?? fallback;
}

function flatten_string_message(value) {
  const parsed_value = parse_unknown_data(value, value);

  if (parsed_value !== value) {
    return flatten_message_parts(parsed_value);
  }

  const trimmed_value = value.trim();
  return trimmed_value ? [trimmed_value] : [];
}

function flatten_array_message(value) {
  return value.flatMap((item) => flatten_message_parts(item));
}

function get_direct_message_value(value) {
  if (value.message != null) return value.message;
  if (value.error != null) return value.error;
  if (value.detail != null) return value.detail;
  return value.non_field_errors;
}

function get_direct_message_parts(value) {
  const direct_message = get_direct_message_value(value);

  if (direct_message == null || direct_message === value) {
    return [];
  }

  return flatten_message_parts(direct_message);
}

function flatten_object_entries(value) {
  return Object.entries(value).flatMap(([key, entry_value]) => {
    if (['message', 'error', 'detail', 'status'].includes(key)) {
      return [];
    }

    const entry_parts = flatten_message_parts(entry_value);
    if (!entry_parts.length) {
      return [];
    }

    return entry_parts.map((part) => `${key}: ${part}`);
  });
}

function flatten_object_message(value) {
  const direct_parts = get_direct_message_parts(value);
  return direct_parts.length ? direct_parts : flatten_object_entries(value);
}

function flatten_message_parts(value) {
  if (value == null) {
    return [];
  }

  if (typeof value === 'string') {
    return flatten_string_message(value);
  }

  if (Array.isArray(value)) {
    return flatten_array_message(value);
  }

  if (typeof value === 'object') {
    return flatten_object_message(value);
  }

  return [String(value)];
}

export function parse_response_data(response) {
  const raw_data = response?.data ?? response ?? {};
  return parse_unknown_data(raw_data, {});
}

export function extract_items(response) {
  const parsed = parse_response_data(response);
  const items = parsed?.data ?? parsed?.results ?? [];

  return Array.isArray(items) ? items : [];
}

export function extract_error_message(error, fallback = 'Something went wrong.') {
  const candidate_sources = [
    error?.response?.data,
    error?.data,
    error?.message,
    error,
  ];

  for (const source of candidate_sources) {
    const parts = flatten_message_parts(source)
      .map((part) => String(part || '').trim())
      .filter(Boolean);

    if (parts.length) {
      return parts.join(', ');
    }
  }

  return fallback;
}
